/**
 * 充值订单状态
 */

import { COLOR_TAG_TYPE } from "./color";

export enum TopUpOrderStatus {
    Default = '',
    Auditing = 0, // 审核中
    Success = 1, // 打款成功
    Fail = 2, // 打款失败
}

export const TopUpOrderStatusList = Object.freeze([
    {
        key: TopUpOrderStatus.Default,
        label: 'account.status.all',
        color: COLOR_TAG_TYPE.default,
    },
    {
        key: TopUpOrderStatus.Auditing,
        label: 'top_up.order_status.init',
        color: COLOR_TAG_TYPE.warning,
    },
    {
        key: TopUpOrderStatus.Success,
        label: 'top_up.order_status.success',
        color: COLOR_TAG_TYPE.success,
    },
    {
        key: TopUpOrderStatus.Fail,
        label: 'top_up.order_status.fail',
        color: COLOR_TAG_TYPE.error,
    },
]);